(function() {
	'use strict';
	
	angular.module('app.core').filter('lineBreaks', function() {
		return function(input) {
			if (!input || typeof input != 'string') {
				return '';
			}
			// replace multiple line breaks with <br><br>
			input = input.replace(/(\r?\n){2,}/g, '<br><br>');
			// replace line breaks with <br>
			input = input.replace(/(\r?\n)/g, '<br>');

			return input;
		};
	});
})();;